var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side_window_container",class:{ 'is-open': _vm.isOpen }},[_vm._t("default",null,{"isSideWindowOpen":_vm.isOpen,"toggleSideWindow":_vm.toggle,"openSideWindow":_vm.open,"closeSideWindow":_vm.close})],2)}
var staticRenderFns = []

export { render, staticRenderFns }